export default __webpack_public_path__ + "static/media/e-faq.eb3ec844.png";